export function setCookie(name, value, days = 7) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Strict`
}
 
export function getCookie(name) {
  return document.cookie.split("; ").reduce((result, part) => {
    const [key, ...val] = part.split("=")
    return key === name ? decodeURIComponent(val.join("=")) : result
  }, null)
}
 
export function deleteCookie(name) {
  // Clear with all possible attribute combinations to ensure deletion
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax`
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=None;Secure`
}

export function clearAllAuthCookies() {
  deleteCookie("accessToken")
  deleteCookie("refreshToken")
  deleteCookie("user")
}